import _ from 'lodash';
import React, { Component } from 'react';

import Select from 'react-select';

const STATUS_OPTIONS = [{
  value: 'open',
  label: 'Open',
},{
  value: 'won',
  label: 'Won',
},{
  value: 'lost',
  label: 'Lost',
}];

class DealStatusSelect extends Component {

  state = {

  }

  getViewingDealsWithStatusSelectValue(){
    const { value } = this.props;

    const matchingOption = _.find(STATUS_OPTIONS, { value });

    return matchingOption;
  }

  render(){
    const selectedOption = this.getViewingDealsWithStatusSelectValue();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container status-select`}
        value={selectedOption}
        options={STATUS_OPTIONS}
        onChange={(option) => { this.props.onUpdate(option.value); }}
        isSearchable={false}
      />
    )
  }
}
export default DealStatusSelect;



// WEBPACK FOOTER //
// ./src/components/shared/dealStatusSelect.js